export default __webpack_public_path__ + "static/media/darklogo.59623698.png";